import { Fragment, useMemo } from "react";
import type { QuoteLineMO } from "~/features/orders/common/components/v2/models";
import type { RenderCboxFn } from "~/features/orders/common/components/v2/QuoteTable/types";
import type { QuoteSelectionStateProps } from "~/features/orders/common/components/v2/QuoteTable/useQuoteDetailsSelectionState";
import { groupByMainQuoteLine } from "~/features/orders/common/components/v2/QuoteTable/utils";
import { SimpleQuoteRow } from "./SimpleQuoteRow";
import { Checkbox, Stack } from "~/common/mui";
import { AdvancedQuoteRow } from "./AdvancedQuoteRow";

interface QuoteTableProps extends Partial<QuoteSelectionStateProps> {
  quoteLines: QuoteLineMO[];
  className?: string;
  showCheckboxes: boolean;
  classes?: {
    headerCheckbox?: string;
    lineItemCheckbox?: string;
  };
}

export const QuoteLineList = ({ quoteLines, ...rest }: QuoteTableProps) => {
  const groupedLines = useMemo(() => groupByMainQuoteLine(quoteLines), [quoteLines]);

  let renderQuoteLineCheckbox: RenderCboxFn = () => null;

  if (rest.showCheckboxes) {
    const { selectedLineNos, toggleLine } = rest as QuoteSelectionStateProps;

    if (rest.toggleLine) {
      renderQuoteLineCheckbox = (quoteLine: QuoteLineMO) => (
        <Checkbox
          disabled={quoteLine.disabled}
          checked={selectedLineNos[quoteLine.lineNo] ?? false}
          onChange={() => toggleLine(quoteLine.lineNo)}
          sx={{ p: 0 }}
        />
      );
    }
  }

  return (
    <Stack gap={2}>
      {groupedLines.map((group) => (
        <Fragment key={group.mainQuoteLine.lineNo}>
          {group.alternativeQuoteLines.length === 0 ? (
            <SimpleQuoteRow quoteLine={group.mainQuoteLine} renderCheckbox={renderQuoteLineCheckbox} />
          ) : (
            <AdvancedQuoteRow {...group} renderCheckbox={renderQuoteLineCheckbox} />
          )}
        </Fragment>
      ))}
    </Stack>
  );
};
